import { render, staticRenderFns } from "./CreateODCMachine.vue?vue&type=template&id=332ff845&scoped=true"
import script from "./CreateODCMachine.vue?vue&type=script&lang=js"
export * from "./CreateODCMachine.vue?vue&type=script&lang=js"
import style0 from "./CreateODCMachine.vue?vue&type=style&index=0&id=332ff845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332ff845",
  null
  
)

export default component.exports